import type { Command } from '@atlaskit/editor-common/types';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { ContentNodeWithPos } from '@atlaskit/editor-prosemirror/utils';
import { fg } from '@atlaskit/platform-feature-flags';

export const createDeleteCommand =
	(selectedNativeEmbed: ContentNodeWithPos): Command =>
	(state, dispatch) => {
		const { pos, node } = selectedNativeEmbed;

		if (fg('platform_native_embeds_full_rollout_bugfix')) {
			const localId: string | undefined =
				typeof node.attrs?.localId === 'string' ? node.attrs.localId : undefined;

			let resolvedPos = pos;
			let resolvedNode: PMNode = node;

			if (localId) {
				const nodeAtCapturedPos = state.doc.nodeAt(pos);
				if (nodeAtCapturedPos?.attrs?.localId === localId) {
					resolvedNode = nodeAtCapturedPos;
				} else {
					let found = false;
					state.doc.descendants((candidateNode, candidatePos) => {
						if (found) {
							return false;
						}
						if (candidateNode.attrs?.localId === localId) {
							resolvedPos = candidatePos;
							resolvedNode = candidateNode;
							found = true;
							return false;
						}
						return true;
					});
					if (!found) {
						return false;
					}
				}
			}
			if (dispatch) {
				dispatch(state.tr.delete(resolvedPos, resolvedPos + resolvedNode.nodeSize));
			}
			return true;
		}

		if (dispatch) {
			dispatch(state.tr.delete(pos, pos + node.nodeSize));
		}
		return true;
	};
